import { Box, Button, Stack, Typography } from "@compass/core";
import { SubmitButton } from "components";
import "moment-timezone";

import { matchReportPageRoute, MatchReportSelection, MatchReportType } from "./MatchReportPage";

export const MatchReportPageHeader = (props: {
  handle: string;
  reportTypes: MatchReportSelection[];
  selectedReportType: MatchReportType | undefined;
  filtersCollapsed: boolean;
  setFilterCollapsed: (value: boolean) => void;
  generateReport: () => void;
}) => {
  const reportType = props.reportTypes.find((x) => x.name === props.selectedReportType);

  return (
    <Stack direction="row" justifyContent="space-between">
      <Typography variant="inherit">{props.handle}</Typography>

      <Stack direction="row" alignItems="center" spacing="sm">
        {props.filtersCollapsed && (
          <Button variant="outlined" onClick={(e) => props.setFilterCollapsed(false)}>
            Back
          </Button>
        )}

        {!props.filtersCollapsed && (
          <SubmitButton
            onClick={props.generateReport}
            label={reportType?.generateTypes.includes("direct-pdf") ? "Open Report in PDF" : "Generate Report"}
          />
        )}
      </Stack>
    </Stack>
  );
};
